import { ApiKey } from '../domain/apiKey/ApiKey';
import { apiKeyRepository } from '../repositories/apiKey';
import { ApiKeyRepository } from '../repositories/apiKey/ApiKeyRepository';

export class ApiKeyService {
  constructor(private apiKeyRepository: ApiKeyRepository) {}

  async create({ label }: { label: string }): Promise<ApiKey> {
    const apiKey = await this.apiKeyRepository.create({
      label,
    });
    return apiKey;
  }

  async fetchAll(): Promise<ApiKey[]> {
    const apiKeys = await this.apiKeyRepository.fetchAll();
    return apiKeys;
  }

  async update({ apiKey }: { apiKey: ApiKey }): Promise<ApiKey> {
    return this.apiKeyRepository.update({ apiKey });
  }

  async delete({ apiKey }: { apiKey: ApiKey }): Promise<ApiKey> {
    await this.apiKeyRepository.delete({ apiKey });
    return apiKey;
  }

  // !!! When the use cases are needed and implemented in the api, uncomment these methods

  // async fetchById({ apiKey_id }: { apiKey_id: string }): Promise<ApiKey> {
  //   const apiKey = await this.apiKeyRepository.fetchById({ apiKey_id });
  //   return apiKey;
  // }

  // async fetchByKey({ apiKey_key }: { apiKey_key: string }): Promise<ApiKey> {
  //   const apiKey = await this.apiKeyRepository.fetchByKey({ apiKey_key });
  //   return apiKey;
  // }

  // !!!
}

export const apiKeyService = new ApiKeyService(apiKeyRepository);
